import Ajax from '@/utils/ajax'
import { mapActions, mapMutations } from 'vuex'

export default {
  methods: {
    ...mapActions(['setFatalError']),
    ...mapMutations(['site']),
    loadRequestParams () {
      let qs = new URLSearchParams(window.location.search)
      const data = (qs && qs.get('data')) ? JSON.parse(window.atob(qs.get('data'))) : {}
      if (!data.origin) this.setFatalError({ description: this.$t('error_missing_param')})
      if (!data.authCode) this.setFatalError({ description: this.$t('error_missing_authcode')})
      this.params = data.params || {}
      this.origin = data.origin || ''
      this.authCode = data.authCode || ''
      this.site(data.site || '')
      if (this.params && this.params.version) this.version = this.params.version
      // console.log('adata', data)
      if (this.origin) return this.loadConfig()
      else this.isLoaded = 0
    },
    loadConfig () {
      const fileName = (process.env.NODE_ENV !== 'production') ? '/config.json.sample' : '/config.json'
      return Ajax.get(fileName)
        .then(rep => {
          try {
            let result = JSON.parse(rep.response)
            return result
          } catch (err) {
            // config.json : must have a envList in websocket mode
            throw new Error(this.$t('error_missing_config'))
          }
        })
        .then(cfg => {
          this.config = cfg
          this.isLoaded = 1
        })
        .catch(err => {
          console.log(err)
          this.isLoaded = 99
        })
    }
  }
}
